<template>
<div
  v-if="visible"
  class="lottie-dialog scroll-fixed"
>
  <div v-if="!isLoading" class="lottie-container" @click.stop>
    <lottie :options="defaultOptions" :height="226.8" :width="218.75" @animCreated="handleAnimation" />
  </div>
  <div v-else class="loading">
      <i class="el-icon-loading" />
  </div>
  <div class="close-lottie pointer">
    <fps-icon class="close-icon" type="close" />
  </div>
</div>
</template>
<script>
import i18n from '@/locales/index'
import lottie from 'vue-lottie'
import axios from 'axios'
import Message from '@/plugins/message'

var lottieAxios = axios.create()

// response interceptor
lottieAxios.interceptors.response.use(
  response => Promise.resolve(response),
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default {
  name: 'Lottie',
  components: {
    lottie
  },
  data() {
    return {
      anim: null,
      visible: false,
      jsonData: null,
      animationSpeed: 1,
      giftId: 0,
      basePath: '',
      isLoading: true
    }
  },
  computed: {
    defaultOptions() {
      if (!this.jsonData) return null
      return {
        loop: false,
        animationData: this.jsonData
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    giftId() {
      this.timer = new Date().getTime()
      this.isLoading = true
      this.getJson()
    }
  },
  mounted() {
    this.timer = new Date().getTime()
    document.body.style.overflow = 'hidden'
    document.addEventListener('click', this.closeLottie)
  },
  methods: {
    getJson() {
      lottieAxios.get(this.basePath)
        .then(rs => {
          this.jsonData = rs.data
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
          this.$message.error(i18n.t('components_sendgifts_components_lottie_1827'))
        })
    },
    cannotScroll(e) {
      e = e || event
      e.preventDefault ? e.preventDefault() : (e.returnValue = false)
    },
    handleAnimation(anim) {
      this.anim = anim
    },
    closeLottie() {
      if (new Date().getTime() - this.timer >= 2000) {
        this.visible = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.loading {
  height:226.8px;
  width:218.75px;
  @include flex();
  font-size: 20px;
}
.load-list {
  width: 0px;
  height: 0px;
  overflow: hidden;
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 6666;
}
.lottie-dialog {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .4);
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.scroll-fixed {
  position: fixed;
}
.lottie-container {
  display: inline-block;
}
.close-lottie {
  border: 2px solid white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  @include flex;
  color: #fff;
  margin-top: 124px;
  .close-icon {
    font-size: 18px;
  }
}
@media screen and (max-width: 599px) {
  .lottie-dialog {
    background: rgba(0, 0, 0, .5);
  }
}
</style>
